import {
  createBrowserRouter,
  Navigate,
  RouterProvider
} from "react-router-dom";

import { PrivateLayout } from "../pages/Layout";
import {
  Error,
  Home,
  Medicos,
  Perfil,
  MedicoView,
  MedicoViewIdLoader,
} from "../pages";
import { ConfiguracionSider } from "../pages/Layout/PrivateLayout/Siders";
import { MedicoHeader } from "../pages/Layout/PrivateLayout/Header/Medico/MedicoHeader";

export const PrivateRouter = () => {

  let homeElement = <Navigate to="home" />;
  
  const router = createBrowserRouter([
    {
      path: "",
      element: <PrivateLayout />,
      errorElement: <Error />,
      children: [
        {
          path: "",
          children: [
            {
              path: "",
              element: homeElement,
            },
          ]
        },
        {
          path: "/home",
          element: <Home />,
        },
        {
          path: "/medicos",
          element: <Medicos />,
        },
        {
          path: "",
          element: <MedicoHeader />,
          children: [
            {
              path: "/medico/view/:id",
              element: <MedicoView />,
              loader: MedicoViewIdLoader,
            }
          ]
        },
        {
          path: "",
          element: <ConfiguracionSider />,
          children: [
            {
              path: "/perfil",
              element: <Perfil />,
            }
          ]
        },
        {
          path: "/*",
          element: <Navigate to="" />,
        }
      ],
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}